import { useMemo } from 'react';
import {
  useExportHistoryListExternalAccountQuery,
  useExportProgressExternalAccountSubscription,
} from '@/common/graphql';
import type { ExportHistoryKind, UseExportHistoryResult } from './types';
import { toExportHistoryRow } from './types';

/** Query + Subscription + row-mapping for `kind: 'externalAccount'`. Always called - internally no-ops via `skip` when inactive. */
export function useExportHistoryExternalAccount(kind: ExportHistoryKind, onlyMyTask: boolean): UseExportHistoryResult {
  const skip = kind !== 'externalAccount';

  const { data, loading, error, refetch } = useExportHistoryListExternalAccountQuery({
    skip,
    fetchPolicy: 'cache-and-network',
    variables: { onlyMyTask },
  });
  const history = useMemo(() => (data?.exportHistoryList ?? []).map(toExportHistoryRow), [data?.exportHistoryList]);

  const { data: progressData } = useExportProgressExternalAccountSubscription({ skip });
  const progress = useMemo(() => progressData?.exportProgress ?? [], [progressData?.exportProgress]);

  return { error, history, isActive: !skip, loading, progress, refetch };
}
